import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Helper function to check if a string is a UUID (valuationId)
const isUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const useFindSlug = () => {
  const location = useLocation();
  const [currentSlug, setCurrentSlug] = useState('');

  useEffect(() => {
    const splitPath = location.pathname.split('/');
    const lastPath = splitPath[splitPath.length - 1];

    // If the last path segment is a UUID (valuationId), use the previous segment as slug
    if (isUUID(lastPath) && splitPath.length > 1) {
      const tableSlug = splitPath[splitPath.length - 2];
      setCurrentSlug(tableSlug);
    } else {
      setCurrentSlug(lastPath);
    }
  }, [location]);

  return currentSlug;
};

export default useFindSlug;
